var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocsInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4225",
    "data-name": "Rectangle 4225",
    width: 26,
    height: 26,
    transform: "translate(569 307)",
    fill: "#f28e39"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_02",
    "data-name": 2,
    transform: "translate(-569 -307)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "archive-book-01",
    transform: "translate(568.75 306.833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9918",
    "data-name": "Path 9918",
    d: "M22.75,7.583V18.417c0,3.25-1.625,5.417-5.417,5.417H8.667c-3.792,0-5.417-2.167-5.417-5.417V7.583c0-3.25,1.625-5.417,5.417-5.417h8.667C21.125,2.167,22.75,4.333,22.75,7.583Z",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9919",
    "data-name": "Path 9919",
    d: "M16.792,2.167v8.515a.544.544,0,0,1-.91.4L13.368,8.764a.537.537,0,0,0-.737,0l-2.513,2.318a.544.544,0,0,1-.91-.4V2.167Z",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9920",
    "data-name": "Path 9920",
    d: "M14.354,15.167h4.6",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9921",
    "data-name": "Path 9921",
    d: "M9.75,19.5h9.208",
    fill: "none",
    stroke: "#292d32",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsInactive);
export default __webpack_public_path__ + "static/media/docs_inactive.c492ed638256e84f217499e19a13c3b6.svg";
export { ForwardRef as ReactComponent };